import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientAllergy } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: PatientAllergy[] = [];

    for (const i in res.data) {
      const { _id, allergy, severity, diagnosis_date } = res.data[i];

      newData.push({
        id: _id,
        allergy,
        severity,
        date: diagnosis_date ? new Date(diagnosis_date) : new Date(), //? Sort them by this date later?
      });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  patientId: string;
}

export const useGetPatientAllergies = ({ patientId }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientQKeys.allergy(patientId),
    queryFn: () => api.get(`patient/allergy/${patientId}`),
    select,

    onError: (res: any) => {
      console.error("[From Get Patient Allergies]", res);
      handleErrors(res, "query");
    },
  });
};
